import config from 'config'
export const openFabraEditor = (query?: Record<string, string>) => {
  const queryString = query ? `?${new URLSearchParams(query).toString()}` : ''
  window.open(`${config.editorDomain}/editor${queryString}`)
}

export const openHelpCenter = () => {
  const url = `${config.domain}/help_center`
  window.open(url)
}

// 创建一个fabra窗口，返回一个打开fabra窗口的函数,防止在异步请求后，窗口被浏览器阻止

export const createFabraWindow = () => {

  const win = window.open(`${config.editorDomain}/editor?loading=true`, '__blank')

  const open = (query?: Record<string, string>) => {
    if (!win) {
      return
    }
    const queryString = query ? `?${new URLSearchParams(query).toString()}` : ''
    win.location.href = `${config.editorDomain}/editor${queryString}`
    win.focus()
  }
  return {
    open,
    close: () => {
      if (win) {
        win.close()
      }
    }
  }
}